var _excluded = ["className", "children"],
    _excluded2 = ["className", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

var MAlogo = function MAlogo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.75 23.25a11.5 11.5 0 1 0-11.5-11.5 11.5 11.5 0 0 0 11.5 11.5z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: ".5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02 13.462h6.108l-.845.942H6.02z",
    fill: "#d44927"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.987 17.816l-1.657-4.419 1.202-1.592 2.372 6.011zm-3.411-9l.91 2.404 1.17-1.56-1.463-3.768a1.105 1.105 0 0 0-.91-.618.942.942 0 0 0-.877.618l-2.86 7.213H9.4l1.624-4.29a.325.325 0 0 1 .26-.162h.033a.26.26 0 0 1 .26.163zm-2.827 5.978l-1.137 3.022H5.695l1.202-3.022z",
    fill: "#222d60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.652 5.014a.585.585 0 0 1 .812-.097.52.52 0 0 1 .097.78l-5.198 7.018q-.065.097-.098.097l-1.04.65c-.065.065-.162 0-.13-.097l.293-1.17c.032-.065.032-.097.065-.13l4.711-6.368-.065-.065c-.032-.033-.097 0-.13.032l-1.527 2.047c.033.065.033.163-.032.195l-.26.358a.162.162 0 0 1-.26.065.195.195 0 0 1-.065-.228h.032l.163-.227.097-.163 1.722-2.34a.357.357 0 0 1 .499-.08l.021.016h.098z",
    fill: "#d44927"
  })));
};

MAlogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  "'data-name'": "Layer 1",
  viewBox: "0 0 23.5 23.5"
};
import Pipeline from '../Pipeline';
import Button, { StyledButton } from '../Button/BaseButton';
var brandColors = {
  baseColor: '#f16522',
  hoverColor: '#b5420b',
  activeColor: '#f69b70',
  foregroundColor: '#FFFFFF'
};
var MAStyledButton = /*#__PURE__*/styled(StyledButton).withConfig({
  displayName: "AlgoSignerButton__MAStyledButton",
  componentId: "sc-1wftqi4-0"
})(["&{transition:all 0.15s ease;}&:hover{box-shadow:0px 2px 4px rgba(0,0,0,0.2);}&& > svg.r-ff-icon{height:", ";width:", ";margin-right:0.5rem;margin-bottom:-2px;}"], function (props) {
  return props.size === 'small' ? '1rem' : '1.5rem';
}, function (props) {
  return props.size === 'small' ? '1rem' : '1.5rem';
});
var StyledButtonSolid = /*#__PURE__*/styled(MAStyledButton).withConfig({
  displayName: "AlgoSignerButton__StyledButtonSolid",
  componentId: "sc-1wftqi4-1"
})(["&{color:", ";background:", ";}&:hover{background-color:", ";}&:active{background-color:", ";}"], brandColors.foregroundColor, brandColors.baseColor, brandColors.hoverColor, brandColors.activeColor);
var StyledButtonOutline = /*#__PURE__*/styled(MAStyledButton).withConfig({
  displayName: "AlgoSignerButton__StyledButtonOutline",
  componentId: "sc-1wftqi4-2"
})(["&{color:#333;background:", ";border:1px solid #ccc;}&:hover{background-color:#f3f2f2;}&:active{background-color:#e4e4e4;}"], brandColors.foregroundColor);

var ButtonBody = function ButtonBody(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MAlogo, {
    className: 'r-ff-icon',
    size: size
  }), children);
};

var MyAlgoButtonSolid = function MyAlgoButtonSolid(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(StyledButtonSolid, _extends({
    className: 'algo-btn-solid'
  }, props), /*#__PURE__*/React.createElement(ButtonBody, {
    children: children,
    size: props.size
  }));
};

var MyAlgoButtonOutline = function MyAlgoButtonOutline(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/React.createElement(StyledButtonOutline, _extends({
    className: 'algo-btn-outline'
  }, props), /*#__PURE__*/React.createElement(ButtonBody, {
    children: children,
    size: props.size
  }));
};

var defaultProps = _objectSpread(_objectSpread({}, Button.defaultProps), {}, {
  width: 'auto',
  borderRadius: 1,
  boxShadow: 1
});

MyAlgoButtonSolid.defaultProps = defaultProps;
MyAlgoButtonOutline.defaultProps = defaultProps;
var MyAlgoButton;
MyAlgoButton = MyAlgoButtonSolid;
MyAlgoButton.Solid = MyAlgoButtonSolid;
MyAlgoButton.Outline = MyAlgoButtonOutline;
MyAlgoButton.propTypes = _objectSpread({}, Button.propTypes);
MyAlgoButton.displayName = 'MyAlgoButton';

var AlgoSignerButton = function AlgoSignerButton(props) {
  return /*#__PURE__*/React.createElement(MyAlgoButton, {
    onClick: function onClick() {
      Pipeline.pipeConnector = 'AlgoSigner';
      Pipeline.connect(props.wallet).then(function (accounts) {
        if (props.returnTo !== undefined) {
          var data = {};
          data[props.returnTo] = accounts;
          props.context.setState(data);
        }

        if (typeof props.onChange === 'function') {
          props.onChange(accounts);
        }
      });
    }
  }, "AlgoSigner");
};

export default AlgoSignerButton;